/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Mutation } from '@apollo/client/react/components';
import BrandsForm from '../components/form';
import { ADD_BRAND } from '../../../../queries/products/brand';

export const AddBrands = (props) => {
  return (
    <Mutation
      mutation={ADD_BRAND}
      update={async () => {
        await props.refetch();
        props.onCloseDrawer();
      }}
    >

      {createTitle => (
        <BrandsForm query_f={createTitle} {...props} />
      )}
    </Mutation>
  );
};
